"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var React = require("react");
var _ = require("lodash");
var Select_style_1 = require("./Select.style");
exports.Select = function (props) {
    var placeholder = props.placeholder, canClose = props.canClose, options = props.options, onChange = props.onChange, error = props.error, value = props.value, borderColor = props.borderColor, required = props.required, rest = __rest(props, ["placeholder", "canClose", "options", "onChange", "error", "value", "borderColor", "required"]);
    var renderList = function () { return _.map(options, function (el) { return (React.createElement("option", { key: el.value, value: el.value }, el.label)); }); };
    return (React.createElement(Select_style_1.default.Wrap, null,
        React.createElement(Select_style_1.default.GlobalStyle, null),
        React.createElement(Select_style_1.default.Select, __assign({ value: value, style: borderColor ? { borderColor: borderColor } : null }, rest, { onChange: function (e) {
                onChange(e);
            } }),
            placeholder ? (React.createElement("option", { value: "", disabled: true },
                placeholder,
                required ? '*' : null)) : null,
            renderList()),
        canClose && value !== '' ? (React.createElement(Select_style_1.default.CloseButon, { onClick: function () {
                onChange('');
            } }, "x")) : null,
        error ? React.createElement(Select_style_1.default.FieldError, null, error) : null));
};
exports.default = exports.Select;
//# sourceMappingURL=Select.js.map